// Mini brand badges for IMDb and Rotten Tomatoes — used in scenepack/movie detail.

export function ImdbBadge({ size = 18 }) {
  return (
    <svg
      viewBox="0 0 64 32"
      height={size}
      width={size * 2}
      aria-label="IMDb"
      className="flex-shrink-0"
    >
      <rect width="64" height="32" rx="6" fill="#F5C518" />
      <text
        x="32"
        y="22"
        textAnchor="middle"
        fontFamily="Impact, 'Arial Black', sans-serif"
        fontSize="18"
        fontWeight="900"
        fill="#000"
        letterSpacing="-1"
      >
        IMDb
      </text>
    </svg>
  );
}

export function RtBadge({ size = 20 }) {
  // Stylized fresh-tomato splat
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} aria-label="Rotten Tomatoes" className="flex-shrink-0">
      <defs>
        <radialGradient id="rt-grad" cx="40%" cy="35%" r="65%">
          <stop offset="0%" stopColor="#FF6A4D" />
          <stop offset="100%" stopColor="#D32F00" />
        </radialGradient>
      </defs>
      <path
        d="M20 4
           C 26 4, 33 7, 35 14
           C 38 15, 39 19, 36 22
           C 38 27, 33 33, 27 33
           C 25 37, 18 37, 15 33
           C 8 33, 3 27, 6 22
           C 3 19, 4 15, 7 14
           C 8 7, 14 4, 20 4 Z"
        fill="url(#rt-grad)"
      />
      {/* leaf */}
      <path d="M19 5 Q22 1 26 3 Q24 8 19 8 Z" fill="#3CA82B" />
      <path d="M20 7 L20 9" stroke="#1F5E1A" strokeWidth="1" strokeLinecap="round" />
    </svg>
  );
}
